/**
 * * Модель представляющая добавление в задачу подзадачи
 */
export default class AttachSubtaskRequest  {
	/**
	 * * Номер задачи
	 */
	TaskId!: number;
	/**
	 * * Номер родителя
	 */
	ParentId!: number;
	constructor(obj?: Partial<AttachSubtaskRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
